import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const Markets = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.markets.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.markets.paragraph" />
          </Subtitle>
        </Contentwrapper>
        <ImageWrapper>
          <StyledImage
            src={messages['home.markets.image.src']}
            alt={messages['home.markets.image.alt']}
          />
        </ImageWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Markets;
